module.exports = __webpack_public_path__ + "static/media/bg-b.415b1ec7.jpg";